import React, { useState, useEffect } from 'react';
import { Box, Collapse, IconButton, InputAdornment, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NoRecord } from '../../../CommonComponent/NoRecord';
import NoDataImg from '../../../../../images/my-goal-bg.svg';
import { AddIconSvg, DeleteIcon, RightArrowIcon } from '../../../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../../../Common/OKRButton';
import { frameworkList, getLevelsByParentAndLevel } from '../../../../../action/adminSettings';
import { useDispatch } from 'react-redux';
import { set } from 'lodash';

export const SkillLevelBox: React.FC<any> = (props: any) => {
	const {
		skillFrameworkId,
		levelData,
		parentLevel,
		saveLevel1Attribute,
		getNextLevelData,
		levelIndex,
		index,
		handleRemoveLevel,
	} = props;
	const [isExpanded, setIsExpanded] = useState<boolean>(true);
	const [levelNewName, setLevelNewName] = useState<any>('');

	const { t } = useTranslation();
	return (
		<Box className='framework-level-list-card'>
			<Box className='framework-level-list-card-inner'>
				<Box className='framework-level-listing-head'>
					<Typography variant='h4'>{parentLevel.levelName}</Typography>
				</Box>
				{levelData.parentData && (
					<Box className='framework-level-listing-content framework-level-child-listing'>
						<Box className='framework-level-listing-content-inner'>
							<Box className='framework-level-attr-list'>
								<Box className='framework-level-attr-row'>
									<Box className='framework-level-attr-col-1'>
										<OKRButton
											className={`expand-collapse-btn ${isExpanded ? 'active' : ''}`}
											icon={<RightArrowIcon />}
											handleClick={() => setIsExpanded(!isExpanded)}
											title={`${isExpanded ? t('collapse') : t('expand')}`}
										/>
										<Typography>{levelData.parentData.name}</Typography>
									</Box>
									<Box className='framework-level-attr-col-2'></Box>
								</Box>
								<Collapse in={isExpanded} timeout='auto' unmountOnExit>
									<Box className='framework-level-child-attr-list'>
										<Box className='framework-level-attribute-field'>
											<TextField
												id={`level-attribute`}
												className='level-attribute-field helperText-bottom'
												placeholder={`Add ${parentLevel.levelName}`}
												value={levelNewName}
												onChange={(e: any) => {
													setLevelNewName(e.target.value);
												}}
												InputLabelProps={{ shrink: true }}
												InputProps={{
													'aria-label': t('Add attributes', {}),
													disableUnderline: true,
													endAdornment: (
														<InputAdornment position='end'>
															<IconButton
																edge='end'
																aria-label={t('Add attribute')}
																onClick={() => {
																	if (levelNewName.trim() !== '') {
																		saveLevel1Attribute(
																			skillFrameworkId,
																			levelData.parentData,
																			parentLevel.levelId,
																			levelNewName
																		);
																		setLevelNewName('');
																	}
																}}
															>
																<AddIconSvg />
															</IconButton>
														</InputAdornment>
													),
												}}
											/>
										</Box>
										{levelData.levelData && levelData.levelData.length > 0 ? (
											levelData.levelData.map((level: any, levelIndex1: number) => (
												<Box className='framework-level-child-attr-row'>
													<Box
														className='framework-level-child-attr-col-1'
														onClick={() => {
															getNextLevelData(levelIndex, index, level);
														}}
													>
														<Typography>{level.name}</Typography>
													</Box>
													<Box className='framework-level-child-attr-col-2'>
														<OKRButton
															icon={<DeleteIcon />}
															handleClick={() =>
																handleRemoveLevel(
																	levelIndex,
																	skillFrameworkId,
																	levelData.parentData,
																	level.id,
																	parentLevel.levelId
																)
															}
															className='editIcon'
															title={t('delete')}
														/>
													</Box>
												</Box>
											))
										) : (
											<></>
										)}
									</Box>
								</Collapse>
							</Box>
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};
